import { Pipe, PipeTransform } from '@angular/core';
import {DictService} from "@ecip/service";


@Pipe({
  name: 'dictLabel'
})
export class DictLabelPipe implements PipeTransform {

  constructor(
    private dictService: DictService,
  ) {

  }

  transform(value: any, type: any): any {
    return this.dictService.dictLabel(type, value);
  }
}
